import { render, staticRenderFns } from "./special-edit.vue?vue&type=template&id=f203e7c0&scoped=true&"
import script from "./special-edit.vue?vue&type=script&lang=ts&"
export * from "./special-edit.vue?vue&type=script&lang=ts&"
import style0 from "./special-edit.vue?vue&type=style&index=0&id=f203e7c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f203e7c0",
  null
  
)

export default component.exports